import { ApiEndpoints } from '../../../utils/app-constants';
import { 
    DOCUMENT_EXTENSIONS,
    DOCUMENT_REQUEST_LOCATION, 
    IDocumentRequest 
} from '../../utilities/document-request';
import { API_METHODS } from '../../utilities/type-models';

export class InvoiceDocument implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab : boolean = false;
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    public url : string = '';

    constructor(id : number, invoiceNumber: string) {
        this.url = ApiEndpoints.ACCOUNTING_INVOICES_REPORT.formattify(id);
        this.filename = invoiceNumber;
    }

}
